<template>
    <DataTable :value="vehiclesGroups" paginator :rows="50" rowHover :loading="loading" stripedRows :sortOrder="-1"
               :filters.sync="filters" sortField="group_vehicles" :rowsPerPageOptions="[10, 25, 50]" :globalFilterFields="['name']"
               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
               :currentPageReportTemplate="$t('AppVehiclesGroupTable.Mostrando {first} até {last} de {totalRecords} Frentes de trabalho')"
               removableSort responsiveLayout="scroll" class="p-datatable-striped">
        <template #header>
            <div class="d-flex justify-content-between">
                <div style="font-size: 20px; font-weight: 500;">
                    {{ $t('AppVehiclesGroupTable.Frentes de trabalho') }}
                </div>
                <div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"/>
                        <InputText v-model="filters['global'].value" :placeholder="$t('AppVehiclesGroupTable.Pesquisar')"/>
                    </span>
                    <Button icon="pi pi-plus" class="p-button-success ml-2" @click="add" :label="$t('AppVehiclesGroupTable.Adicionar')"/>
                </div>
            </div>
        </template>
        <template #empty>
            {{ $t('AppVehiclesGroupTable.Nenhuma frente de trabalho localizada') }}
        </template>
        <template #loading>
            {{ $t('AppVehiclesGroupTable.Carregando, aguarde') }}
        </template>
        <Column field="name" :header="$t('AppVehiclesGroupTable.Nome')" headerClass="headerClass" bodyClass="bodyClass"
                sortable :showFilterMenu="false" :showClearButton="false"/>
        <Column headerClass="headerClass" bodyClass="bodyClass" :styles="{'max-width':'10rem'}">
            <template #body="slotProps">
                <div>
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-info mx-md-1 mx-0"
                            @click="edit(slotProps.data)" v-tooltip.top="$t('AppVehiclesGroupTable.Editar')"/>
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mx-md-1 mx-0"
                            @click="remove(slotProps.data)" v-tooltip.top="$t('AppVehiclesGroupTable.Remover')"/>
                </div>
            </template>
        </Column>
    </DataTable>
</template>

<script>

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tooltip from 'primevue/tooltip';
import InputText from "primevue/inputtext";
import Button from 'primevue/button';

import {FilterMatchMode} from "primevue/api";

export default {
    data() {
        return {
            filters: {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS}
            }
        }
    },
    props: {
        vehiclesGroups: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean
        }
    },
    methods: {
        add() {
            this.$emit('add');
        },
        edit(vehiclesGroup) {
            this.$emit('edit', vehiclesGroup);
        },
        remove(vehiclesGroup) {
            this.$emit('remove', vehiclesGroup);
        }
    },
    directives: {
        'tooltip': Tooltip
    },
    components: {Button, InputText, DataTable, Column, Tooltip}
}
</script>

<style lang="scss">
@import "/src/assets/styles/primevue";
</style>
